<template>
  <header v-if="show" class="km-desktop-nav">
    <div class="km-dn__inner">
      <!-- Brand -->
      <router-link to="/Home" class="km-dn__brand">
        <svg class="km-dn__icon" viewBox="0 0 40 40" fill="none">
          <path d="M20 34s-12-7.4-12-16a7 7 0 0 1 12-4.9A7 7 0 0 1 32 18c0 8.6-12 16-12 16z" fill="url(#kmdn-g)"/>
          <defs>
            <linearGradient id="kmdn-g" x1="8" y1="8" x2="32" y2="34">
              <stop stop-color="#ff4d8d"/><stop offset="1" stop-color="#a020f0"/>
            </linearGradient>
          </defs>
        </svg>
        <span class="km-dn__name">KissMora</span>
      </router-link>

      <!-- Nav items -->
      <nav class="km-dn__nav">
        <router-link
          v-for="n in navItems"
          :key="n.path"
          :to="n.path"
          class="km-dn__item"
          :class="[{ active: isActive(n) }, n.fab && 'km-dn__item--fab', n.featured && 'km-dn__item--featured']"
        >
          <span class="km-dn__item-emoji">{{ n.emoji }}</span>
          <span>{{ $t(n.labelKey) }}</span>
        </router-link>
      </nav>

      <!-- Right cluster: bell + profile -->
      <div class="km-dn__right">
        <router-link to="/Notice" class="km-dn__bell" aria-label="Notifications">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
          <span v-if="unread > 0" class="km-dn__bell-badge">{{ unread > 9 ? '9+' : unread }}</span>
        </router-link>
        <router-link to="/Mine" class="km-dn__avatar" aria-label="Profile">
          <img v-if="avatar" :src="avatar" alt="me" @error="avatar=''" />
          <svg v-else viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M12 12a5 5 0 1 0-5-5 5 5 0 0 0 5 5Zm0 2c-3.33 0-10 1.67-10 5v3h20v-3c0-3.33-6.67-5-10-5Z"/></svg>
        </router-link>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'DesktopNav',
  data(){
    return {
      avatar: '',
      unread: 0,
      navItems: [
        { path:'/Home',    id:'home',    labelKey:'nav.home',    emoji:'🏠' },
        { path:'/Video',   id:'video',   labelKey:'nav.cam',     emoji:'🎬' },
        { path:'/Choose',  id:'choose',  labelKey:'nav.choose',  emoji:'💘', featured: true },
        { path:'/Lottery', id:'lottery', labelKey:'nav.certify', emoji:'🏅' }
      ]
    };
  },
  computed: {
    show(){
      if(!localStorage.getItem('token')) return false;
      const n = this.$route && this.$route.name;
      const HIDE = ['landing','login','register','login-legacy','register-legacy'];
      return HIDE.indexOf(n) === -1;
    }
  },
  watch: {
    show(v){ if(v){ this.fetchAvatar(); this.fetchUnread(); } }
  },
  mounted(){
    if(this.show){ this.fetchAvatar(); this.fetchUnread(); }
    // refresh unread every 60s while nav is mounted
    this.$options._pollUnread = setInterval(() => {
      if(this.show) this.fetchUnread();
    }, 60000);
    // and whenever the user returns to /Notice — the page marks read → refresh badge
    this.$options._onFocus = () => { if(this.show) this.fetchUnread(); };
    window.addEventListener('focus', this.$options._onFocus);
  },
  beforeDestroy(){
    clearInterval(this.$options._pollUnread);
    if(this.$options._onFocus) window.removeEventListener('focus', this.$options._onFocus);
  },
  methods: {
    isActive(n){
      const name = this.$route && this.$route.name;
      if(n.id === 'home')    return name === 'home';
      if(n.id === 'video')   return name === 'video';
      if(n.id === 'choose')  return ['choose','matches'].indexOf(name) !== -1;
      if(n.id === 'lottery') return name === 'Lottery';
      return false;
    },
    fetchAvatar(){
      const cached = localStorage.getItem('km_avatar');
      if(cached) this.avatar = cached;
      if(this.$http) this.$http({ method:'get', url:'user_info' }).then(res => {
        if(res && res.code === 200 && res.data && res.data.header_img){
          this.avatar = res.data.header_img;
          try { localStorage.setItem('km_avatar', res.data.header_img); } catch(e){ /* ignore */ }
        }
      }).catch(() => {});
    },
    fetchUnread(){
      if(!this.$http) return;
      this.$http({ method:'get', url:'notice_unread_count' }).then(res => {
        if(res && res.code === 200 && res.data && typeof res.data.count === 'number'){
          this.unread = res.data.count;
        }
      }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.km-desktop-nav {
  /* hide on mobile — bottom bar handles those sizes */
  display: none;
}

@media (min-width: 960px) {
  .km-desktop-nav {
    display: block;
    position: fixed; top: 0; left: 0; right: 0; z-index: 55;
    background: rgba(255,255,255,.88);
    backdrop-filter: blur(24px) saturate(170%);
    -webkit-backdrop-filter: blur(24px) saturate(170%);
    border-bottom: 1px solid rgba(26,16,51,.06);
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, "PingFang SC", sans-serif;
  }
  .km-dn__inner {
    max-width: 1280px; margin: 0 auto;
    padding: 10px 24px; height: 64px;
    display: flex; align-items: center; gap: 20px;
  }

  .km-dn__brand {
    display: flex; align-items: center; gap: 10px;
    text-decoration: none; flex-shrink: 0;
  }
  .km-dn__icon { width: 30px; height: 30px; }
  .km-dn__name {
    font-size: 20px; font-weight: 800; letter-spacing: -.02em;
    background: linear-gradient(90deg, #ff4d8d, #a020f0);
    -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent;
  }

  .km-dn__nav {
    flex: 1;
    display: flex; justify-content: center; gap: 4px;
  }
  .km-dn__item {
    display: inline-flex; align-items: center; gap: 7px;
    padding: 9px 16px; border-radius: 999px;
    text-decoration: none; color: #4a3d66;
    font-size: 14px; font-weight: 600;
    transition: background .2s, color .2s, transform .15s;
  }
  .km-dn__item-emoji { font-size: 15px; line-height: 1; }
  .km-dn__item:hover { background: rgba(255,77,141,.08); color: #1a1033; transform: translateY(-1px); }
  .km-dn__item.active {
    background: linear-gradient(90deg, rgba(255,77,141,.12), rgba(160,32,240,.12));
    color: #ff4d8d;
  }
  /* The Discover entry gets a distinct pink→purple gradient pill look */
  .km-dn__item--fab {
    background: linear-gradient(90deg, #ff4d8d, #a020f0);
    color: #fff;
    box-shadow: 0 6px 14px rgba(255,77,141,.3);
    padding: 9px 18px;
  }
  .km-dn__item--fab:hover {
    background: linear-gradient(90deg, #ff4d8d, #a020f0);
    color: #fff;
    box-shadow: 0 10px 20px rgba(255,77,141,.45);
  }
  .km-dn__item--fab.active {
    background: linear-gradient(90deg, #ff4d8d, #a020f0);
    color: #fff;
    box-shadow: 0 0 0 3px rgba(255,77,141,.25), 0 10px 20px rgba(255,77,141,.45);
  }

  /* "Choose" — classier & slightly larger than peers */
  .km-dn__item--featured {
    background: linear-gradient(135deg, #fff 0%, #ffe8f0 100%);
    color: #ff4d8d;
    padding: 11px 22px;
    border: 1.5px solid rgba(255,77,141,.25);
    box-shadow: 0 8px 18px rgba(255,77,141,.18);
    font-weight: 800;
    font-size: 15px;
  }
  .km-dn__item--featured .km-dn__item-emoji { font-size: 17px; }
  .km-dn__item--featured:hover {
    background: linear-gradient(135deg, #fff 0%, #ffd7e3 100%);
    color: #ff4d8d;
    border-color: #ff4d8d;
    box-shadow: 0 12px 24px rgba(255,77,141,.28);
    transform: translateY(-2px);
  }
  .km-dn__item--featured.active {
    background: linear-gradient(90deg, #ff4d8d, #a020f0);
    color: #fff;
    border-color: transparent;
    box-shadow: 0 0 0 3px rgba(255,77,141,.25), 0 12px 24px rgba(255,77,141,.45);
  }

  .km-dn__right { display: flex; align-items: center; gap: 10px; flex-shrink: 0; }
  .km-dn__bell {
    position: relative;
    width: 40px; height: 40px; border-radius: 12px;
    background: #fff; border: 1px solid rgba(26,16,51,.08);
    display: flex; align-items: center; justify-content: center;
    color: #1a1033; text-decoration: none;
    transition: border-color .2s, transform .15s;
  }
  .km-dn__bell:hover { border-color: #ff4d8d; transform: translateY(-1px); color: #ff4d8d; }
  .km-dn__bell-badge {
    position: absolute; top: -4px; right: -4px;
    min-width: 18px; height: 18px; padding: 0 5px;
    border-radius: 999px;
    background: linear-gradient(135deg, #ff4d8d, #a020f0);
    color: #fff; font-size: 10px; font-weight: 800; line-height: 18px;
    text-align: center;
    box-shadow: 0 2px 6px rgba(255,77,141,.4), 0 0 0 2px #fff;
  }
  .km-dn__avatar {
    position: relative;
    width: 40px; height: 40px; border-radius: 50%;
    background: #fff;
    display: flex; align-items: center; justify-content: center; overflow: hidden;
    color: #a020f0;
    box-shadow: 0 0 0 2px rgba(255,77,141,.5), 0 4px 12px rgba(160,32,240,.2);
    transition: transform .15s, box-shadow .2s;
    text-decoration: none;
  }
  .km-dn__avatar:hover { transform: translateY(-1px); box-shadow: 0 0 0 2px #ff4d8d, 0 6px 16px rgba(160,32,240,.3); }
  .km-dn__avatar img { width: 100%; height: 100%; object-fit: cover; }
}
</style>
